import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { App } from './App';
import './styles.css';

const rootEl = document.getElementById('root');
if (!rootEl) {
  throw new Error('Root element #root not found in index.html');
}

// StrictMode is a no-op in production builds, but in dev it double-invokes
// effects + state-initializers — which on mobile WebViews (Capacitor, Pixel
// LAN-dev-server testing) makes hot-path effects (useFrame, useGLTF, scene
// .traverse) cost twice as much and can mask real perf issues. Keep the
// double-render discipline in CI/desktop dev only.
const root = createRoot(rootEl);
if (import.meta.env.DEV && !navigator.userAgent.match(/Android|iPhone|iPad/i)) {
  root.render(<StrictMode><App /></StrictMode>);
} else {
  root.render(<App />);
}
